import { liffLog } from '@/lib/liff-log';

const LIVE_LIFF_ID = '1660658846-mqn8A2xE';

let liffInitialized = false;

export async function resolveLineAuth(store) {
  liffLog.info('resolveLineAuth start', { liffId: LIVE_LIFF_ID, liffInitialized });

  if (typeof window === 'undefined' || !window.liff) {
    liffLog.error('LIFF SDK not loaded (window.liff missing)');
    throw new Error('LIFF SDK not loaded');
  }

  // Only init once per page load — re-calling liff.init() after client-side
  // navigation strips LIFF query params, which can cause the SDK to throw or
  // lose auth state on some versions.
  if (!liffInitialized) {
    try {
      await window.liff.init({ liffId: LIVE_LIFF_ID });
      liffInitialized = true;
      liffLog.info('liff.init done');
    } catch (error) {
      liffLog.error('liff.init failed', error);
      throw error;
    }

    await window.liff.ready;
    liffLog.info('liff.ready', liffLog.snapshot());
  } else {
    liffLog.info('liff already initialized — skipping liff.init()');
  }

  if (!window.liff.isInClient()) {
    liffLog.warn('Not in LINE client — redirecting to OA', {
      href: window.location.href,
      ...liffLog.snapshot(),
    });
    window.location.href = 'https://page.line.me/398javpp';
    return;
  }

  if (!window.liff.isLoggedIn()) {
    liffLog.info('Not logged in — calling liff.login()');
    window.liff.login({ redirectUri: window.location.href });
    return;
  }

  // If store already has lineUid (set during earlier init), no need to
  // call getProfile again on subsequent entry-page visits.
  if (store.state.lineUid) {
    liffLog.info('lineUid already in store — skipping getProfile', {
      lineUid: store.state.lineUid,
    });
    return;
  }

  try {
    const profile = await window.liff.getProfile();
    liffLog.info('getProfile ok', {
      userId: profile.userId,
      displayName: profile.displayName,
    });
    store.commit('SET_LINEUID', profile.userId);
    store.commit('SET_LINEDISPLAYNAME', profile.displayName);
  } catch (error) {
    liffLog.error('getProfile failed', error);
    throw error;
  }
}
